function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
class ColorUtils {
  /**
   * THIS HAS POOR PERFORMANCE DUE TO DOM MANIPULATION
   * Attempt to get the rgb or rgba string for a color string. If the color string
   * can't be resolved to a valid color, null is returned.
   * @param colorString The color string to resolve
   */
  static asRgbOrRgbaString(colorString) {
    if (
    // Since dom manipulation is expensive, we want to avoid it if possible.
    /^rgb/.test(colorString) || /^rgba/.test(colorString) || /^color\(srgb/.test(colorString)) {
      return colorString;
    }
    var divEl = document.createElement('div');
    divEl.style.display = 'none';
    divEl.style.backgroundColor = colorString;
    var color = window.getComputedStyle(document.body.appendChild(divEl)).getPropertyValue('background-color');
    divEl.remove();
    return color || null;
  }

  /**
   * THIS HAS POOR PERFORMANCE DUE TO DOM MANIPULATION
   * DO NOT USE HEAVILY
   * Checks if a background color is dark (i.e. should use a light foreground).
   *
   * @param background the background color
   */
  static isDark(background) {
    var d = document.createElement('div');
    d.style.display = 'none';
    d.style.backgroundColor = background;
    var computedColor = getComputedStyle(document.body.appendChild(d)).backgroundColor;
    var colorTokens = computedColor.match(/\d+/g);
    var color = [];
    if (colorTokens) {
      color = colorTokens.map(a => parseInt(a, 10));
    } else {
      throw new Error("Invalid color received. Got ".concat(computedColor));
    }
    document.body.removeChild(d);
    var brightness = ColorUtils.getBrightness(color);
    return brightness < 125;
  }

  // Note: leaving this as arbitrary length number[] in case of RGBA().
  static getBrightness(color) {
    // http://www.w3.org/TR/AERT#color-contrast
    return Math.round((color[0] * 299 + color[1] * 587 + color[2] * 114) / 1000);
  }

  /**
   * THIS HAS POOR PERFORMANCE DUE TO DOM MANIPULATION
   * Normalize a css color to 8 character hex value (or 6 character hex if
   * isAlphaOptional is true and alpha is 'ff'). If the color can't be resolved,
   * return the original string.
   * @param colorString The color string to normalize
   * @param isAlphaOptional If true, the alpha value will be dropped if it is 'ff'.
   * Defaults to false.
   */
  static normalizeCssColor(colorString) {
    var isAlphaOptional = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var maybeRgbOrRgba = ColorUtils.asRgbOrRgbaString(colorString);
    if (maybeRgbOrRgba == null) {
      return colorString;
    }
    var rgba = ColorUtils.parseRgba(maybeRgbOrRgba);
    if (rgba === null) {
      return colorString;
    }
    var hex8 = ColorUtils.rgbaToHex8(rgba);
    if (isAlphaOptional === true) {
      return hex8.replace(/^(#[a-f0-9]{6})ff$/, '$1');
    }
    return hex8;
  }

  /**
   * Parse a given `rgb` or `rgba` css expression into its constituent r, g, b, a
   * values. If the expression cannot be parsed, it will return null.
   * Note that this parser is more permissive than the CSS spec and shouldn't be
   * relied on as a full validation mechanism. For the most part, it assumes that
   * the input is already a valid rgb or rgba expression.
   *
   * e.g. `rgb(255, 255, 255)` -> `{ r: 255, g: 255, b: 255, a: 1 }`
   * e.g. `rgba(255, 255, 255, 0.5)` -> `{ r: 255, g: 255, b: 255, a: 0.5 }`
   * e.g. `color(srgb 1 1 0 / 0.25)` -> `{ r: 255, g: 255, b: 0, a: 0.25 }`
   * @param rgbOrRgbaString The rgb or rgba string to parse
   */
  static parseRgba(rgbOrRgbaString) {
    var _rgbOrRgbaString$matc;
    // if color(srgb) format, we handle that differently

    var _ref = (_rgbOrRgbaString$matc = rgbOrRgbaString.match(
      // loose with the regex to allow for different formats between browsers
      // take the first 4 digits that look like numbers, including decimals
      // We've already checked it's a valid color with CSS.supports
      /(?:\b\d+\.\d*|\b\d+|\.\d+)/g)) !== null && _rgbOrRgbaString$matc !== void 0 ? _rgbOrRgbaString$matc : [],
      _ref2 = _slicedToArray(_ref, 4),
      r = _ref2[0],
      g = _ref2[1],
      b = _ref2[2],
      a = _ref2[3];
    if (r == null || g == null || b == null) {
      return null;
    }
    if (rgbOrRgbaString.startsWith('color(srgb')) {
      return {
        r: Math.round(Number(r) * 255),
        g: Math.round(Number(g) * 255),
        b: Math.round(Number(b) * 255),
        a: Number(a !== null && a !== void 0 ? a : 1)
      };
    }

    // return 1 for any alpha value greater than 1
    return {
      r: Number(r),
      g: Number(g),
      b: Number(b),
      a: Math.min(Number(a !== null && a !== void 0 ? a : 1), 1)
    };
  }

  /**
   * Convert an rgba object to an 8 character hex color string.
   * @param r The red value
   * @param g The green value
   * @param b The blue value
   * @param a The alpha value (defaults to 1)
   * @returns The a character hex string with # prefix
   */
  static rgbaToHex8(_ref3) {
    var r = _ref3.r,
      g = _ref3.g,
      b = _ref3.b,
      _ref3$a = _ref3.a,
      a = _ref3$a === void 0 ? 1 : _ref3$a;
    // eslint-disable-next-line no-param-reassign
    a = Math.round(a * 255);
    var _map = [r, g, b, a].map(v => v.toString(16).padStart(2, '0')),
      _map2 = _slicedToArray(_map, 4),
      rh = _map2[0],
      gh = _map2[1],
      bh = _map2[2],
      ah = _map2[3];
    return "#".concat(rh).concat(gh).concat(bh).concat(ah);
  }
}
export default ColorUtils;
//# sourceMappingURL=ColorUtils.js.map